import * as React from 'react'
import { createPortal } from 'react-dom'
import { Link } from 'react-router-dom'
import XIcon from 'lucide-react/dist/esm/icons/x'
import MobileFeaturesGroup from './MobileFeaturesGroup'

export default function MobileDrawer({ onClose }: { onClose: () => void }) {
  if (typeof document === 'undefined') return null

  const handleCreateAccount = () => {
    const signupUrl = `${AUTH0_DOMAIN}/authorize?` +
      `client_id=${AUTH0_CLIENT_ID}&` +
      `response_type=code&` +
      `redirect_uri=${encodeURIComponent(APP_REDIRECT_URL)}&` +
      `scope=openid%20profile%20email&` +
      `prompt=login&` +
      `screen_hint=signup`;
    onClose();
    window.location.href = signupUrl;
  };
  return createPortal(
    <div className="fixed inset-0 z-[60]">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} aria-hidden="true" />
      <aside
        className="absolute inset-x-0 top-0 w-full max-h-[80vh] bg-white/80 backdrop-blur-lg border border-white/60 shadow-xl overflow-y-auto transition-transform duration-200 ease-out will-change-transform data-[state=open]:translate-x-0 data-[state=closed]:translate-x-full"
        data-state="open"
        role="dialog"
        aria-modal="true"
        aria-label="Mobile navigation"
      >
        <button className="absolute right-3 top-3 p-2" onClick={onClose} aria-label="Close menu">
          <XIcon />
        </button>
        <nav className="p-5 pt-14 pb-8 space-y-3 text-joey-navy text-base font-medium">
          <Link to="/" className="block" onClick={onClose}>Home</Link>
          <MobileFeaturesGroup onClose={onClose} />
          <Link to="/about-us" className="block" onClick={onClose}>About Us</Link>
          <Link to="/articles" className="block" onClick={onClose}>Articles</Link>
          <div className="pt-3 border-t border-gray-200/70 mt-3" />
          <div className="flex flex-col gap-3 pb-4">
            <a
              href="https://app.joeyfamily.com/login"
              className="w-full text-center border border-joey-navy text-joey-navy rounded-full py-3 font-semibold hover:bg-joey-navy/5 transition-colors"
              onClick={onClose}
            >
              Login
            </a>
            <button
              onClick={handleCreateAccount}
              className="w-full text-center bg-joey-navy text-white rounded-full py-3 font-semibold hover:bg-joey-navy/90 transition-colors"
            >
              Get Started
            </button>
          </div>
        </nav>
      </aside>
    </div>,
    document.body
  )
}
